import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { inputCls, Field, Panel, btnPrimary, errMsg } from "./ui";

export default function PaymentTimeoutPanel() {
  const [minutes, setMinutes] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/payment").then((r) => setMinutes(r.data.timeout_minutes)); }, []);
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await api.put("/settings/payment", { timeout_minutes: Number(minutes) });
      setMinutes(r.data.timeout_minutes);
      toast.success("Batas waktu bayar disimpan");
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };
  return (
    <Panel title="Batas Waktu Bayar" testId="pay-timeout-panel">
      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        <Field label="Batas waktu (menit)">
          <input data-testid="pay-timeout-input" type="number" min="5" max="10080" required className={inputCls} value={minutes} onChange={(e) => setMinutes(e.target.value)} />
        </Field>
        <button data-testid="pay-timeout-save-btn" type="submit" disabled={saving} className={btnPrimary}>{saving ? "Menyimpan..." : "Simpan"}</button>
      </form>
      <p className="text-xs text-[#A8A8AD] mt-4">Pesanan yang belum mengunggah bukti bayar sampai batas ini otomatis dibatalkan, stok dikembalikan, dan Saldo Store yang dipakai dikembalikan ke pembeli. Pesanan yang sudah upload bukti tidak ikut dibatalkan. Berlaku untuk pesanan baru.</p>
    </Panel>
  );
}
